// extracted by mini-css-extract-plugin
module.exports = {"carouselTitle":"_2BKJ2h6J4BTQ6sNahx099F"};